import { IProduct } from "../product";

export interface IPromoProduct {
  promoProductId: number;
  promotedPrice: number | null;
  discountPercentage: number | null;
  discountAmount: number | null;
  packQuantity: number | null;
  unitSize: number | null;
  unitOfMeasure: string | null;
  product: IProduct | null;
}


export class PromoProduct implements IPromoProduct {
    private readonly _promoProductId: number;
    private readonly _promotedPrice: number | null;
    private readonly _discountPercentage: number | null;
    private readonly _discountAmount: number | null;
    private readonly _packQuantity: number | null;
    private readonly _unitSize: number | null;
    private readonly _unitOfMeasure: string | null;
    private readonly _product: IProduct | null;

    constructor(
        promoProductId: number,
        promotedPrice: number | null,
        discountPercentage: number | null,
        discountAmount: number | null,
        packQuantity: number | null,
        unitSize: number | null,
        unitOfMeasure: string | null,
        product: IProduct | null
    ) {
        this._promoProductId = promoProductId;
        this._promotedPrice = promotedPrice;
        this._discountPercentage = discountPercentage;
        this._discountAmount = discountAmount;
        this._packQuantity = packQuantity;
        this._unitSize = unitSize;
        this._unitOfMeasure = unitOfMeasure;
        this._product = product;
    }

    get promoProductId(): number {
        return this._promoProductId;
    }

    get promotedPrice(): number | null {
        return this._promotedPrice;
    }

    get discountPercentage(): number | null {
        return this._discountPercentage;
    }

    get discountAmount(): number | null {
        return this._discountAmount;
    }

    get packQuantity(): number | null {
        return this._packQuantity;
    }

    get unitSize(): number | null {
        return this._unitSize;
    }

    get unitOfMeasure(): string | null {
        return this._unitOfMeasure;
    }

    get product(): IProduct | null {
        return this._product;
    }
}

export const getBlankPromoProducts = (count: number): PromoProduct[] => {
  return Array.from(
    { length: count },
    () =>
      new PromoProduct(
        0,
        null,
        null,
        null,
        null,
        null,
        null,
        null
      )
  );
};